import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b8a8461"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-goods-index" }
const _hoisted_2 = {
  class: "viscidity",
  ref: "viscidity"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "swiper_open" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "custom-indicator" }
const _hoisted_7 = { class: "swipe_num" }
const _hoisted_8 = { class: "swipe_num1" }
const _hoisted_9 = {
  key: 1,
  class: "van-swipe swiper_open_div"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "seckill"
}
const _hoisted_12 = { class: "seckill-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Flash" }, "Flash sale", -1))
const _hoisted_14 = { class: "price" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "count_down" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "right" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode()
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, ":", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, ":", -1))
const _hoisted_24 = { class: "card" }
const _hoisted_25 = {
  key: 0,
  class: "price"
}
const _hoisted_26 = {
  key: 2,
  class: "new_hand"
}
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "ranking" }
const _hoisted_29 = { class: "rate" }
const _hoisted_30 = {
  key: 1,
  class: "card"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "promotions" }, "Promotions", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Buy items up to ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(", and get ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" off ")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Free gifts ")
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Free gifts ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Claim Now ")
const _hoisted_42 = { class: "card" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select Variation:", -1))
const _hoisted_44 = { class: "card" }
const _hoisted_45 = {
  key: 2,
  id: "comment",
  class: "card",
  ref: "commentRef"
}
const _hoisted_46 = { class: "gift comment" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Customer reviews ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("View All ")
const _hoisted_49 = { class: "card shopping" }
const _hoisted_50 = { class: "shopping-top" }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, null, -1))
const _hoisted_53 = { class: "shopping-center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Score", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "All products", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Followers", -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Chat with this seller ")
const _hoisted_60 = {
  class: "card",
  id: "descruptions",
  ref: "descruption"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Product Description", -1))
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = ["src"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 3,
  class: "card"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gift comment" }, [
  /*#__PURE__*/_createElementVNode("span", null, " From The Same Store ")
], -1))
const _hoisted_70 = { class: "same_store" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 4,
  class: "card"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gift comment" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Best Sellers Related to This Item ")
], -1))
const _hoisted_74 = { class: "same_store" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "actionbar" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "voucher_style" }
const _hoisted_79 = { class: "anniversary_box" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anniversary_title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Free Shipping")
], -1))
const _hoisted_81 = { class: "anniversary_text" }
const _hoisted_82 = ["innerHTML"]
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Buy items up to ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" , and get ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" off, ")
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Gift:   Free gifts while ")
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "mt-1 kilimall_display" }, "stock last", -1))
const _hoisted_90 = [
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = {
  key: 0,
  class: "present"
}
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["src"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "x1", -1))
const _hoisted_95 = { class: "present" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_login = _resolveComponent("google-login")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_Header = _resolveComponent("Header")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_Voucher = _resolveComponent("Voucher")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_Recommend = _resolveComponent("Recommend")!
  const _component_van_action_bar_icon = _resolveComponent("van-action-bar-icon")!
  const _component_van_action_bar_button = _resolveComponent("van-action-bar-button")!
  const _component_van_action_bar = _resolveComponent("van-action-bar")!
  const _component_Sku = _resolveComponent("Sku")!
  const _component_Provinces = _resolveComponent("Provinces")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_Appad = _resolveComponent("Appad")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_google_login),
      _createElementVNode("div", {
        class: _normalizeClass($setup.isShowAppad ? 'appadClass' : '')
      }, [
        _createVNode(_component_Header, {
          backgroundColor: "#fff",
          fontColor: "#000",
          skipPath: $setup.skipPath,
          shareState: "",
          menuState: ""
        }, {
          center: _withCtx(() => [
            _createVNode(_component_van_search, {
              modelValue: _ctx.searchKeyword,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKeyword) = $event)),
                _ctx.updateValue
              ],
              shape: "round",
              "left-icon": 
              'https://image.kilimall.com/kenya/new_wap/search/ic_search_nor@2x.png'.webpFilters()
            ,
              placeholder: "I'm looking for...",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/search-middle'))),
              ref: "refsFocus"
            }, null, 8, ["modelValue", "left-icon", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["skipPath"])
      ], 2),
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabs, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item,
            class: _normalizeClass({ viscidity_active: $setup.viscidity_tabs === index }),
            onClick: ($event: any) => ($setup.viscidity_func(index))
          }, _toDisplayString(item), 11, _hoisted_3))
        }), 128))
      ], 512),
      _createElementVNode("div", _hoisted_4, [
        (
          $setup.goods.albums && $setup.goods.albums.length >= 0 && $setup.swiper_status === true
        )
          ? (_openBlock(), _createBlock(_component_van_swipe, {
              key: 0,
              onChange: $setup.onChange,
              autoplay: 3000
            }, {
              indicator: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString($setup.current + 1), 1),
                  _createElementVNode("span", _hoisted_8, "/" + _toDisplayString($setup.small_pic ? $setup.small_pic.length : "0"), 1)
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.small_pic, (item) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    class: "swper-item",
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item.images ? _ctx.webpFilters(item.images.L) : '',
                        alt: ""
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: $setup.small_pic[0].images ? _ctx.webpFilters($setup.small_pic[0].images.L) : '',
                alt: ""
              }, null, 8, _hoisted_10)
            ]))
      ]),
      (
        $setup.goods.flash_info &&
        $setup.goods.flash_info.time_status &&
        $setup.goods.flash_info.storage != 0
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                ($setup.goods.promotion_price)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_15, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($setup.get_price_fn().thousands()), 1))
                  : _createCommentVNode("", true),
                ($setup.goods.marketprice && $setup.get_price_fn() != $setup.goods.marketprice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.currencyUnit) + _toDisplayString($setup.goods.marketprice.thousands()), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                class: "imgs",
                src: 
            'https://image.kilimall.com/kenya/new_wap/voucher/05f9cd36f50bee2e0c414dd8680642c.png'.webpFilters()
          ,
                alt: ""
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", null, _toDisplayString($setup.flashDesc), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, _toDisplayString($setup.countDownList[0]), 1),
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("span", null, _toDisplayString($setup.countDownList[1]), 1),
                    _hoisted_22,
                    _hoisted_23,
                    _createElementVNode("span", null, _toDisplayString($setup.countDownList[2]), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        ($setup.goods.flash_info == '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($setup.goods.promotion_price).thousands()), 1),
                _createElementVNode("em", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($setup.goods.marketprice).thousands()), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString($setup.get_price_type_fn()) + " %OFF", 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.postageData.isFreePostage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "anniversary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.get_voucher_now_fn(0)))
            }, [
              _createElementVNode("p", null, "Free Shipping (Orders Above KSh " + _toDisplayString($setup.postageData.freePostageThresholdAmount) + ")", 1),
              _createVNode(_component_van_icon, { name: "arrow" })
            ]))
          : _createCommentVNode("", true),
        ($setup.goods.new_user_goods_info && $setup.goods.new_user_goods_info != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt(
                $setup.goods.new_user_goods_info.newuser_goods_price
              ).thousands()), 1),
                _createElementVNode("em", null, _toDisplayString($setup.goods.new_user_goods_info.newuser_goods_hint), 1)
              ]),
              _createElementVNode("h2", null, _toDisplayString($setup.goods.new_user_goods_info.buy_limit) + " piece(s) maximum per buyer. ", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, _toDisplayString($setup.goods.name), 1),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_van_rate, {
              modelValue: $setup.goods.rate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.goods.rate) = $event)),
              size: 25,
              "allow-half": "",
              color: "#ffd21e",
              "void-icon": "star",
              "void-color": "#eee"
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", null, _toDisplayString(parseInt($setup.goods.rate) === parseFloat($setup.goods.rate)
              ? $setup.goods.rate + ".0"
              : $setup.goods.rate), 1)
          ])
        ])
      ]),
      (
        ($setup.goods.mansong_info && $setup.goods.mansong_info.length > 0) ||
        ($setup.goods.goods_gifts && $setup.goods.goods_gifts.length > 0) ||
        ($setup.goods_voucher && $setup.goods_voucher.length > 0)
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _hoisted_31,
            (
          ($setup.goods.mansong_info &&
            $setup.goods.mansong_info.length > 0 &&
            !($setup.goods.flash_info && $setup.goods.flash_info.discount)) ||
          ($setup.goods.mansong_info &&
            $setup.goods.mansong_info.length > 0 &&
            $setup.goods.flash_info &&
            $setup.goods.flash_info.time_status != 2)
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods.mansong_info, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "special",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.get_voucher_now_fn(0))),
                      key: item.goods_id
                    }, [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + _toDisplayString(item.price.thousands()), 1),
                      _hoisted_34,
                      _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(item.discount.thousands()), 1),
                      _hoisted_35,
                      ($setup.goods.goods_gifts && $setup.goods.goods_gifts.length > 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_36, ",and get "))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (
            $setup.goods.mansong_info &&
            $setup.goods.mansong_info.length > 0 &&
            $setup.goods.mansong_info.mansong_goods_name
          )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "gift",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.get_voucher_now_fn(0)))
                      }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("img", {
                            src: 
                'https://image.kilimall.com/kenya/new_wap/voucher/ic_gift-box@2x.png'.webpFilters()
              ,
                            alt: ""
                          }, null, 8, _hoisted_37),
                          _hoisted_38
                        ]),
                        _createElementVNode("span", null, "X" + _toDisplayString($setup.goods.mansong_info ? $setup.goods.mansong_info.length : ""), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (
          $setup.goods.mansong_info &&
          $setup.goods.mansong_info.length <= 0 &&
          $setup.goods.goods_gifts &&
          $setup.goods.goods_gifts.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "gift",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.get_voucher_now_fn(1)))
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: 
              'https://image.kilimall.com/kenya/new_wap/voucher/ic_gift-box@2x.png'.webpFilters()
            ,
                      alt: ""
                    }, null, 8, _hoisted_39),
                    _hoisted_40
                  ]),
                  _createElementVNode("span", null, "X " + _toDisplayString($setup.goods.goods_gifts ? $setup.goods.goods_gifts.length : "0"), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.goods_voucher && $setup.goods_voucher.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "voucher",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.get_voucher_now_fn(2)))
                }, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods_voucher.slice(0, 2), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.voucher_price
                      }, [
                        _createVNode(_component_Voucher, {
                          details_voucher_state: "",
                          item: item
                        }, null, 8, ["item"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("h5", null, [
                    _hoisted_41,
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", {
          class: "gift variation",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.AddToCart(1))),
          style: {"margintop":"0"}
        }, [
          _hoisted_43,
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.colorValue, (item, index) => {
                return (_openBlock(), _createElementBlock("i", { key: item }, " \"" + _toDisplayString(item) + "\" " + _toDisplayString($setup.colorValue.length != index + 1 ? "," : ""), 1))
              }), 128))
            ]),
            _createVNode(_component_van_icon, { name: "arrow" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        ($setup.goods.logistics_type == 2)
          ? (_openBlock(), _createBlock(_component_van_cell, {
              key: 0,
              class: "shipped_item",
              border: false,
              center: true,
              title: "Oversea Shipment",
              icon: 
          'https://image.kilimall.com/kenya/PcImages/global.png'.webpFilters()
        
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        ($setup.goods.logistics_type == 1)
          ? (_openBlock(), _createBlock(_component_van_cell, {
              key: 1,
              class: "shipped_item",
              border: false,
              center: true,
              title: "Fulfilled by Kilimall",
              icon: 
          'https://image.kilimall.com/kenya/PcImages/kilimall.png'.webpFilters()
        
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        ($setup.goods.logistics_type == 0)
          ? (_openBlock(), _createBlock(_component_van_cell, {
              key: 2,
              class: "shipped_item",
              border: false,
              center: true,
              title: "Local Dispatch",
              icon: 
          'https://image.kilimall.com/kenya/PcImages/local.png'.webpFilters()
        
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        ($setup.goods.is_free_shipping == 1)
          ? (_openBlock(), _createBlock(_component_van_cell, {
              key: 3,
              class: "shipped_item",
              border: false,
              center: true,
              title: "Free Shipping for Kilishop",
              icon: 
          'https://image.kilimall.com/kenya/PcImages/free-delivery.png'.webpFilters()
        
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]),
      ($setup.commentList && $setup.commentList.list && $setup.commentList.list.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_router_link, {
                to: '/comment-list?goodsId=' + $setup.goods.goods_commonid
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_47,
                    _createElementVNode("em", null, "(" + _toDisplayString($setup.commentList.totalNum ? $setup.commentList.totalNum : "0") + ")", 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("span", null, [
                _createVNode(_component_router_link, {
                  to: '/comment-list?goodsId=' + $setup.goods.goods_commonid
                }, {
                  default: _withCtx(() => [
                    _hoisted_48,
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("ul", {
              class: _normalizeClass(["exhibition", { unfold_active: $setup.active === true }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.commentList.list, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.goodsId
                }, [
                  _createVNode(_component_Comment, { item: item }, null, 8, ["item"])
                ]))
              }), 128))
            ], 2),
            _createElementVNode("div", {
              class: "arrow-down",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.arrow_fnc && $setup.arrow_fnc(...args)))
            }, [
              _createVNode(_component_van_icon, {
                size: "16",
                class: "#999999",
                name: $setup.active === true ? 'arrow-up' : 'arrow-down'
              }, null, 8, ["name"])
            ])
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.goods.id ? $setup.jump_link() : null))
          }, [
            _createElementVNode("img", {
              src: 
              $setup.store_info.store_avatar
                ? $setup.store_info.store_avatar
                : 'https://image.kilimall.com/kenya/wap/default/head.png'.webpFilters()
            ,
              alt: ""
            }, null, 8, _hoisted_51)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString($setup.store_info.name), 1),
            _hoisted_52
          ]),
          _createElementVNode("div", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.goods.id ? $setup.jump_link() : null))
          }, "visit store")
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($setup.store_info.store_servicecredit), 1),
            _hoisted_54
          ]),
          _hoisted_55,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($setup.store_info.goods_count), 1),
            _hoisted_56
          ]),
          _hoisted_57,
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($setup.store_info.followed), 1),
            _hoisted_58
          ])
        ]),
        _createElementVNode("div", {
          class: "shopping-buttom",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.linkChat && $setup.linkChat(...args)))
        }, [
          _createVNode(_component_van_icon, {
            name: "chat-o",
            color: "#44BB63"
          }),
          _hoisted_59
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        ($setup.product.intro != '')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "descruption",
              innerHTML: $setup.product.intro
            }, null, 8, _hoisted_62))
          : (_openBlock(), _createElementBlock("div", _hoisted_63, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.product.mobile_body_arr, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "descruption",
                  key: item.value
                }, [
                  (item.type == 'image')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        (item.type == 'image' && item.text)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: item.text
                            }, null, 8, _hoisted_65))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: item.value,
                              alt: ""
                            }, null, 8, _hoisted_66))
                      ]))
                    : (item.type=="text")
                      ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(item.value), 1))
                      : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ], 512),
      ($setup.store_recommend && $setup.store_recommend.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("ul", _hoisted_70, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store_recommend, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.goods_id,
                  onClick: ($event: any) => ($setup.current_jump(item, item.goods_id, 1))
                }, [
                  _createVNode(_component_Recommend, { data: item }, null, 8, ["data"])
                ], 8, _hoisted_71))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.recommend_list && $setup.recommend_list.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("ul", _hoisted_74, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recommend_list, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  onClick: ($event: any) => ($setup.current_jump(item, item.goods_id, 2))
                }, [
                  _createVNode(_component_Recommend, { data: item }, null, 8, ["data"])
                ], 8, _hoisted_75))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_76, [
        _createVNode(_component_van_action_bar, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_action_bar_icon, {
              icon: "chat-o",
              text: "Chat",
              onClick: $setup.linkChat
            }, null, 8, ["onClick"]),
            _createVNode(_component_van_action_bar_icon, {
              icon: $setup.follow_status === 0 ? 'like-o' : 'like',
              color: $setup.follow_status === 0 ? 'inherit' : '#f76900',
              text: "Wish",
              onClick: $setup.star_func
            }, null, 8, ["icon", "color", "onClick"]),
            _createVNode(_component_van_action_bar_icon, {
              icon: "cart-o",
              text: "Cart",
              badge: $setup.shopping_number ? $setup.shopping_number : 0,
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.router.push('/cart?isShowCart=hidden')))
            }, null, 8, ["badge"]),
            ($setup.seckill_btns)
              ? (_openBlock(), _createBlock(_component_van_action_bar_button, {
                  key: 0,
                  type: "warning",
                  onClick: $setup.AddToCart,
                  text: "Add To Cart"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($setup.seckill_btns)
              ? (_openBlock(), _createBlock(_component_van_action_bar_button, {
                  key: 1,
                  type: "danger",
                  onClick: $setup.buy_now_fn,
                  text: "Order Now"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!$setup.seckill_btns)
              ? (_openBlock(), _createBlock(_component_van_action_bar_button, {
                  key: 2,
                  class: "seckill_btns",
                  type: "danger",
                  text: "Flash Buy",
                  onClick: $setup.buy_now_fn
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Sku, {
      modelValue: $setup.skuShow,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.skuShow) = $event)),
      sku: $setup.goods.spec_list,
      goods: $setup.goods,
      variation: $setup.variation,
      seckill: $setup.get_price_fn(),
      follow_status: $setup.follow_status,
      seckill_btns: $setup.seckill_btns,
      onStar_func: $setup.star_func,
      onSkuSelected: $setup.skuSelected,
      onAddCart: $setup.addCart,
      onVariation_fuc: $setup.variation_fuc
    }, null, 8, ["modelValue", "sku", "goods", "variation", "seckill", "follow_status", "seckill_btns", "onStar_func", "onSkuSelected", "onAddCart", "onVariation_fuc"]),
    _createVNode(_component_van_popup, {
      show: $setup.site_show,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (($setup.site_show) = $event)),
      position: "bottom",
      closeable: "",
      style: { height: '60%' }
    }, {
      default: _withCtx(() => [
        ($setup.site_show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
              _createVNode(_component_Provinces, {
                onRegion_fnc: $setup.region_fnc,
                site_show: $setup.site_show
              }, null, 8, ["onRegion_fnc", "site_show"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: $setup.voucher_show,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => (($setup.voucher_show) = $event)),
      position: "bottom",
      closeable: "",
      style: { height: '60%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("p", {
                innerHTML: $setup.postageData.freePostageText
              }, null, 8, _hoisted_82)
            ])
          ]),
          _createVNode(_component_van_tabs, {
            type: "card",
            active: $setup.activeName,
            "onUpdate:active": _cache[16] || (_cache[16] = ($event: any) => (($setup.activeName) = $event))
          }, {
            default: _withCtx(() => [
              ($setup.goods.mansong_info && $setup.goods.mansong_info.length > 0)
                ? (_openBlock(), _createBlock(_component_van_tab, {
                    key: 0,
                    title: "promotions"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods.mansong_info, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "special",
                          key: index
                        }, [
                          _hoisted_83,
                          _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(item.price.thousands()), 1),
                          _hoisted_84,
                          _createElementVNode("span", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(item.discount.thousands()), 1),
                          _hoisted_85,
                          _createElementVNode("strong", null, [
                            (item.goods_id && item.mansong_goods_name)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_86, "and get "))
                              : _createCommentVNode("", true),
                            (item.goods_id && item.mansong_goods_name)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_87, _hoisted_90))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      ($setup.goods.mansong_info[0].mansong_goods_name)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_91, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods.mansong_info, (item, key) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: key,
                                onClick: ($event: any) => ($setup.present_fnc(item))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.webpFilters(item.mansong_goods_images.ORIGIN),
                                  alt: ""
                                }, null, 8, _hoisted_93),
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", null, _toDisplayString(item.mansong_goods_name), 1),
                                  _hoisted_94
                                ])
                              ], 8, _hoisted_92))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.goods_voucher && $setup.goods_voucher.length > 0)
                ? (_openBlock(), _createBlock(_component_van_tab, {
                    key: 1,
                    title: "Voucher"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods_voucher, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.voucher_price
                          }, [
                            _createVNode(_component_Voucher, {
                              item: item,
                              type: "shop",
                              onGet_voucher_fn: ($event: any) => ($setup.get_voucher_now_fnction(item))
                            }, null, 8, ["item", "onGet_voucher_fn"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.goods.goods_gifts && $setup.goods.goods_gifts.length > 0)
                ? (_openBlock(), _createBlock(_component_van_tab, {
                    key: 2,
                    title: "Gift"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_95, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goods.goods_gifts, (item, key) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: key,
                            onClick: ($event: any) => ($setup.present_fnc(item))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.webpFilters(item.images.M),
                              alt: ""
                            }, null, 8, _hoisted_97),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", null, _toDisplayString(item.gift_goodsname), 1),
                              _createElementVNode("span", null, "x" + _toDisplayString(item.gift_amount ? item.gift_amount : 1), 1)
                            ])
                          ], 8, _hoisted_96))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["active"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_Appad, {
      isShowPopUp: $setup.isShowAppad,
      onCloseFn: $setup.closeFn,
      app_adjust_arr: $setup.app_adjust_arr
    }, null, 8, ["isShowPopUp", "onCloseFn", "app_adjust_arr"])
  ], 64))
}